import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class StaffGroupsApi extends ApiModule {
	constructor() {
		super(ModulesMap.STAFF_GROUPS, {
			entity: 'staff_groups',
		})
	}
}
